import PHOTO_NOT_AVAILABLE from 'images/ui/no-hotel-photo-available.gif';

export function getImage(image) {
  if(!image) return PHOTO_NOT_AVAILABLE;
  const url = image.url;
  return url ? (url.startsWith('http') ? url : `/images/entities/${url}`): PHOTO_NOT_AVAILABLE;
}

export function getLogoFromUserAccount(userAccount){
  return getLogoFromAccount(userAccount && userAccount.account || undefined);
}

export function getLogoFromAccount(account){
  const logo = account && account.logo || undefined;
  return logo? `/images/logos/${logo}`: undefined;
}


export function parseWebsite(ws){
  if(!ws) return undefined;
  return ws.match(/^http[s]?:\/\//i) ? ws : `http://${ws}`;
}

export function comparisonForStringsAndNumbers(a,b) {
  const aNumber = typeof a === 'number', bNumber = typeof b === 'number';
  if(aNumber && aNumber === bNumber){
    return a-b;
  } else if(aNumber){
    return 1;
  } else if(bNumber){
    return -1;
  } else {
    return comparisonForStrings(a,b);
  }
}

export function comparisonForStrings(a,b) {
  return (a || '').localeCompare(b, 'US', {sensitivity: 'base'});
}
